// constants
import { CouponActionTypes } from "./constants";

export interface CouponActionType {
  type:
    | CouponActionTypes.API_RESPONSE_SUCCESS
    | CouponActionTypes.API_RESPONSE_ERROR
    | CouponActionTypes.UPDATE_COUPONS
    | CouponActionTypes.CREATE_COUPONS
    | CouponActionTypes.GET_COUPONS
    | CouponActionTypes.GET_COUPONS_INFLUENCERS
    | CouponActionTypes.GET_COUPONS_REPORT
    | CouponActionTypes.DELETE_COUPONS;
  payload: {} | string;
}

interface CouponDetails {
  id: string;
  name: string;
  phone: string;
  email: string;
  coupon_code: string;
  expire_in: string;
  is_active: boolean;
  max_apply_limit: string;
}

// common success
export const CouponApiResponseSuccess = (actionType: string, data: CouponDetails | {}): CouponActionType => ({
  type: CouponActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CouponApiResponseError = (actionType: string, error: string): CouponActionType => ({
  type: CouponActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createCoupon = (
  coupon_code: string,
  start_in: string,
  expire_in: string,
  max_apply_limit: string,
  coupon_percentage: any,
  commision_percentage: any,
  influencer?: number | string
): CouponActionType => ({
  type: CouponActionTypes.CREATE_COUPONS,
  payload: {
    coupon_code,
    start_in,
    expire_in,
    max_apply_limit,
    coupon_percentage,
    commision_percentage,
    influencer,
  },
});

export const getCoupon = (): CouponActionType => ({
  type: CouponActionTypes.GET_COUPONS,
  payload: {},
});

export const getInfluencerByCoupon = (influencer: number | string): CouponActionType => ({
  type: CouponActionTypes.GET_COUPONS_INFLUENCERS,
  payload: { influencer },
});

export const deleteCoupon = (id: string, influencer?: number | string): CouponActionType => ({
  type: CouponActionTypes.DELETE_COUPONS,
  payload: { id, influencer },
});
export const updateCoupon = (
  id: string,
  coupon_code: string,
  start_in: string,
  expire_in: string,
  max_apply_limit: string,
  coupon_percentage: any,
  commision_percentage: any,
  influencer?: number | string
): CouponActionType => ({
  type: CouponActionTypes.UPDATE_COUPONS,
  payload: {
    id,
    coupon_code,
    expire_in,
    start_in,
    max_apply_limit,
    coupon_percentage,
    commision_percentage,
    influencer,
  },
});

export const getCouponReport = (type: string, from?: any, to?: any): CouponActionType => ({
  type: CouponActionTypes.GET_COUPONS_REPORT,
  payload: {
    type,
    from,
    to,
  },
});
